export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sport.vue?vue&type=template&id=5ab46ad2"


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/pages/sport/sport.vue?vue&type=template&id=5ab46ad2
// module id = OM3F
// module chunks = 37